import { Button } from "@/design-system/components/Button/Button";
import { colors } from "@material-ui/core";
import React from "react";

import { ConfigureDestinationsModal } from "../../modals/ConfigureDestinationsModal";
import { GoogleOAuthConfigModal } from "../../modals/GoogleOAuthConfigModal";
import { DestinationConfigRow } from "../shared/ConfigPageRow";
import { GoogleCampaignManager360Icon } from "../../../components/icons/themes/logos";

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings } = existingConfig;

  return (
    <ConfigureDestinationsModal
      limitSettings={["profileId", "advertiserId"]}
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idsSet = "profileId" in settings && "advertiserId" in settings;

  return (
    <DestinationConfigRow
      name="Configuration"
      textColor={idsSet ? "" : colors.red[600]}
      labelText={idsSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  // only show the oauth flow if we're in server side mode
  var enable_row = existingConfig.connection_mode !== "server" ? true : false;

  // this comes from the google app verification process. They want links that
  // say Google Ads, to also have the icon. But also not show the icon alone
  // afaict. So we show <icon> Connect with Google if oauth is not configured.
  var icon = (
    <GoogleCampaignManager360Icon
      className="position mr-2 fill-white"
      height="2em"
      style={{ top: -2 }}
    />
  );

  const loginButton = (
    <Button
      variant="outline"
      onClick={setConfigModalOpen}
      className="text-grey font-semi-bold inline-block w-auto cursor-pointer rounded px-2 py-1"
    >
      {!oauthConfigured && icon}
      {oauthConfigured ? "Reconnect" : "Connect With Google CM360"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access Permission"
      disabled={enable_row}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CONFIG = "CONFIG";
const OAUTH = "OAUTH";

const Rows = {
  [CONFIG]: ConfigurationRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [CONFIG]: ConfigurationModal,
  [OAUTH]: GoogleOAuthConfigModal,
};

const RowOrder = [CONFIG, OAUTH];

export default {
  Rows,
  RowOrder,
  Modals,
};
